"use client";

import { clientConfig } from "@/lib/rollbar";
import { Provider as RollbarProvider } from "@rollbar/react";

export default function Providers({
  children,
}: {
  children: React.ReactNode;
}): React.ReactNode {
  return <RollbarProvider config={clientConfig}>{children}</RollbarProvider>;
}
